<div class="flex h-full">
  <!-- Left side - Image and branding -->
  <div class="hidden md:flex md:w-2/3 bg-gray-100 relative overflow-hidden">
    <!-- Full image background -->
    <img src="assets/images/login.jpg" alt="Background" class="absolute object-cover w-full h-full">

    <!-- Strategic gradient overlay for better text readability -->
    <div class="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/0"></div>

    <!-- Content positioned in the most readable area -->
    <div class="absolute inset-x-0 bottom-0 p-12 pr-0 z-10">
      <div class="flex items-center flex-row gap-4 mb-2">
        <img src="assets/images/app-logo.webp" class="h-10 w-10">
        <h1 class="text-5xl font-bold text-white tracking-tight" translate="no">Mr. Kresz</h1>
      </div>
      <p class="text-xl text-white/90 max-w-md">Üdvözlünk a partnerközösségben!</p>
    </div>
  </div>

  <!-- Right side - Login form -->
  <div class="w-full md:w-1/2 flex items-center justify-center p-8 bg-white">
    <div class="max-w-md w-full">
      <!-- Mobile logo only -->
      <div class="flex flex-col items-center md:hidden mb-10">
        <img src="assets/images/app-logo.webp" class="h-16 mb-2">
        <div class="text-xl font-bold"><span translate="no">Mr. Kresz</span> partner</div>
      </div>

      <h2 class="text-2xl font-bold mb-6 text-center">Bejelentkezés</h2>

      <form class="w-full" [formGroup]="loginFG">
        <div class="mb-4">
          <mat-form-field class="w-full">
            <mat-label>E-mail cím</mat-label>
            <input matInput formControlName="emailFC" />
            <mat-error>Kötelező mező!</mat-error>
          </mat-form-field>
        </div>

        <div class="mb-6">
          <mat-form-field class="w-full">
            <mat-label>Jelszó</mat-label>
            <input matInput [type]="showPassword ? 'text' : 'password'" formControlName="passwordFC">
            <button mat-icon-button matSuffix type="button" (click)="showPassword = !showPassword" tabindex="-1">
              <mat-icon>{{ showPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
            </button>
            <mat-error>Kötelező mező!</mat-error>
          </mat-form-field>
        </div>

        <div class="flex justify-center">
          <button class="app-button w-full" (click)="login()" [disabled]="isLoading" [class.button-loading]="isLoading">
            Bejelentkezés
          </button>
        </div>

        <div class="mt-4 text-center">
          <a routerLink="/forgot-password" class="text-primary hover:underline">
            Elfelejtett jelszó?
          </a>
        </div>
      </form>
    </div>
  </div>
</div>
